module.exports = function getResource(label) {
    let resources = {
        seeMore: 'Voir plus',
        showMore: 'Afficher plus'
    };
    return resources[label];
};
